import { jsx } from "react/jsx-runtime";
import { useEditorComponents } from "../../hooks/EditorComponentsContext.mjs";
function DefaultLoadingScreen() {
  const { Spinner } = useEditorComponents();
  return /* @__PURE__ */ jsx("div", { className: "tl-loading", "aria-busy": "true", tabIndex: 0, children: Spinner ? /* @__PURE__ */ jsx(Spinner, {}) : null });
}
export {
  DefaultLoadingScreen
};
//# sourceMappingURL=DefaultLoadingScreen.mjs.map
